import React, { useCallback } from 'react';
import Header from './Header';
import About from './About';
// import Work from './Work';
import Skills from './Skills';
import { Box } from '@mui/material';
import Projects from './Projects';
import AboutMe from './AboutMe';
import Footer from './Footer';
import { loadSlim } from 'tsparticles-slim';
import Particles from 'react-particles';
import particlesConfigDark from './../assets/config/particlesConfigDark.json';
import particlesConfigLight from './../assets/config/particlesConfigLight.json';

export default function Home({ onThemeToggle, darkMode }) {
    const particlesInit = useCallback(async (engine) => {
        console.log(engine);
        await loadSlim(engine);
    }, []);

    const particlesLoaded = useCallback(async (container) => {
        console.log(container);
    }, []);

    return (
        <Box
            sx={{
                scrollBehavior: 'smooth',
            }}
        >
            <Header onThemeToggle={onThemeToggle} darkMode={darkMode} />

            <Box id="about">
                <About darkMode={darkMode} />
            </Box>
            <Box id="aboutMe">
                <AboutMe darkMode={darkMode} />
            </Box>
            <Box id="skills">
                <Skills darkMode={darkMode} />
            </Box>
            <Box id="projects">
                <Projects darkMode={darkMode} />
            </Box>
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={darkMode ? particlesConfigDark : particlesConfigLight}
            />
            <Box id="contact">
                <Footer />
            </Box>
        </Box>
    );
}
